import { useCallback, useEffect, useState } from 'react'
import AlertsService from '../../../services/api/AlertsService'

const INITIAL_PAGY = { page: 1, pages: 0, count: 0, items: 0 }
const SEARCH_KEY = 'q'

const buildParams = ({ page, items, search, sort, direction }) => {
  const result = { page, items }
  result[SEARCH_KEY] = search
  if (sort) {
    result.sort = sort
    result.direction = direction
  }
  return result
}

const useConfiguredAlerts = (collectId, params) => {
  const { page, items, sort, direction } = params
  const search = params[SEARCH_KEY]
  const [alerts, setAlerts] = useState([])
  const [pagy, setPagy] = useState(INITIAL_PAGY)
  const [loading, setLoading] = useState(true)
  const [hasLoaded, setHasLoaded] = useState(false)
  const [error, setError] = useState(null)
  const [refetchToken, setRefetchToken] = useState(0)

  const refetch = useCallback(() => setRefetchToken(token => token + 1), [])

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)

    AlertsService.getAlerts(
      collectId, buildParams({ page, items, search, sort, direction })
    ).then(response => {
      if (cancelled)
        return
      setAlerts(response.alerts || [])
      setPagy(response.pagy || INITIAL_PAGY)
    }).catch(err => {
      if (cancelled)
        return
      setError(err)
      setAlerts([])
      setPagy(INITIAL_PAGY)
    }).finally(() => {
      if (cancelled)
        return
      setLoading(false)
      setHasLoaded(true)
    })

    return () => {
      cancelled = true
    }
  }, [collectId, page, items, search, sort, direction, refetchToken])

  return { alerts, pagy, loading, hasLoaded, error, refetch }
}

export default useConfiguredAlerts
